import { NButton, NDropdown, NIcon } from '@innersource-nn/novoui-react';
import { ButtonConfig } from './Header';
import { Tooltip } from '@mui/material';
import { DropdownIndicator, NovoIconNames } from '@novonordisk/novoui-vuejs';
interface DropdownMenuProps {
    buttonConfigs: ButtonConfig[];
}

export default function DropdownMenu({ buttonConfigs }: DropdownMenuProps) {
    const allDisabled =
        buttonConfigs?.every((button) => button.disabled) ?? false;
    return (
        <NDropdown
            indicator={DropdownIndicator.RIGHT}
            activator={
                <NButton
                    icon="ellipsisVert"
                    square
                    variant="outline"
                    disabled={allDisabled}
                />
            }
            content={
                <div className="dropdown-sections">
                    <div className="dropdown-section">
                        {buttonConfigs.map(
                            (button: ButtonConfig, sectionIndex: number) => (
                                <Tooltip
                                    title={button.tooltip}
                                    key={`${sectionIndex}-tooltip`}
                                    placement="left"
                                    arrow
                                >
                                    <button
                                        key={`${sectionIndex}`}
                                        className={
                                            button.red
                                                ? 'dropdown-option-red'
                                                : 'dropdown-option'
                                        }
                                        onClick={button.onClick}
                                    >
                                        <>
                                            <div
                                                className={
                                                    button.red
                                                        ? 'dropdown-option-icon-red'
                                                        : 'dropdown-option-icon'
                                                }
                                            >
                                                <NIcon
                                                    iconName={
                                                        button.icon as NovoIconNames
                                                    }
                                                    size="normal"
                                                />
                                            </div>
                                            <p
                                                className={
                                                    (button.red
                                                        ? 'dropdown-option-label-red'
                                                        : 'dropdown-option-label ml-24') +
                                                    ' text-base	'
                                                }
                                            >
                                                {button.label}
                                            </p>
                                        </>
                                    </button>
                                </Tooltip>
                            ),
                        )}
                    </div>
                </div>
            }
            activatorSize="medium"
            selectMode={false}
        />
    );
}
